var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"multiple":_vm.isMany,"filterable":"","remote":"","disabled":_vm.disable,"reserve-keyword":"","placeholder":"请输入关键词","remote-method":_vm.remoteMethod,"loading":_vm.loading},on:{"change":_vm.handleChange},model:{value:(_vm.uids),callback:function ($$v) {_vm.uids=$$v},expression:"uids"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73128166","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/UserSelectCorp.vue
// module id = 1213
// module chunks = 0